import React from 'react';
import config from '../config';
import DashboardInitializer from '../dashboards/DashboardInitializer';
import apiPaths from '../apiPaths';

const NotaDashboard = (props) => {
  const components = [
    {
      params: {
        type: 'search',
        componentId: 'notanotaSearch',
        panelHeader: 'Nota',
        panelKey: 'notanotaSearch',
        yPosition: 0,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabIndex: 0,
        tabTitle: '',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 0,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'nota',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'fkAlumno.id',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'fkGradacion.id',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'fkRegistro.id',
                  yPosition: 2,
                  xPosition: 2,
                  mustRender: true,
                  width: 12,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Nota',
          key: 'nota',
          type: 'number',
          operand: 'like',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Alumne',
          key: 'fkAlumno.id',
          type: 'combo',
          operand: 'like',
          comboId: 'alumno',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Gradació',
          key: 'fkGradacion.id',
          type: 'combo',
          operand: 'like',
          comboId: 'gradacion',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Registre',
          key: 'fkRegistro.id',
          type: 'combo',
          operand: 'like',
          comboId: 'registro',
          mandatory: false,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
      },
    },
    {
      params: {
        type: 'table',
        componentId: 'notanotaList',
        rowKey: 'id',
        panelHeader: 'Nota',
        panelKey: 'notanotaList',
        navigationParams: props.query.params.q || '',
        yPosition: 1,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabTitle: '',
        isMainTable: true,
        tabIndex: 0,
        tableType: 0,
      },
      fields: [
        {
          title: 'Id',
          dataIndex: 'id',
          position: 0,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          width: 60,
        },
        {
          title: 'Nota',
          dataIndex: 'nota',
          position: 1,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          width: 60,
        },
        {
          title: 'Alumne',
          dataIndex: 'fkAlumno.id',
          position: 2,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          render: 'combo',
          comboId: 'alumno',
        },
        {
          title: 'Gradació',
          dataIndex: 'fkGradacion.nombre',
          position: 3,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Registre',
          dataIndex: 'fkRegistro.nombre',
          position: 4,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
      ],
      settings: {
        size: config.COMPONENT.TABLE.SIZE,
        bordered: config.COMPONENT.TABLE.BORDERED,
        editable: true,
        multiple: false,
        canCreate: true,
        canDelete: true,
        scroll: { x: true },
      },
      pagination: {
        defaultPageSize: 50,
        pageSizeOptions: ['5', '10', '20', '50'],
        showQuickJumper: config.COMPONENT.SHOW_QUICK_JUMPER,
        showSizeChanger: config.COMPONENT.TABLE.SHOW_SIZE_CHANGER,
        showTotal: config.COMPONENT.TABLE.SHOW_TOTAL,
        size: config.COMPONENT.TABLE.SIZE,
      },
    },
    {
      params: {
        type: 'edit',
        componentId: 'notanotaEdit',
        panelHeader: 'Nota',
        panelKey: 'notanotaEdit',
        primaryKey: 'id',
        yPosition: 2,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: true,
        tabIndex: 0,
        tabTitle: 'Nota',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 2,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'nota',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 18,
                },
                {
                  key: 'fkAlumno.id',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 18,
                },
                {
                  key: 'fkGradacion.id',
                  yPosition: 3,
                  xPosition: 1,
                  mustRender: true,
                  width: 18,
                },
                {
                  key: 'fkRegistro.id',
                  yPosition: 4,
                  xPosition: 1,
                  mustRender: true,
                  width: 18,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Nota',
          key: 'nota',
          type: 'number',
          unique: false,
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Alumne',
          key: 'fkAlumno.id',
          type: 'combo',
          unique: false,
          comboId: 'alumno',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Gradació',
          key: 'fkGradacion.id',
          type: 'combo',
          unique: false,
          comboId: 'gradacion',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Registre',
          key: 'fkRegistro.id',
          type: 'combo',
          unique: false,
          comboId: 'registro',
          mandatory: true,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
        canEdit: true,
        canCreate: true,
        canDelete: true,
      },
    },
  ];

  const componentId = 'NotaDashboard';

  return (
    <DashboardInitializer
      componentId={componentId}
      components={components}
      {...props}
    />
  );
};

export default NotaDashboard;
